// 薬師丸賢太 個別設定 (A セット認証) が動作している状態か。
// pharmacy_code の編集ロック判定などで使う。
export const isYakumaruCustomSettingActive = (
  setting?: { active?: boolean | null; useCustomSetting?: boolean | null } | null,
): boolean => !!setting?.active && !!setting?.useCustomSetting;
